import Vue from 'vue'
import Vuex from 'vuex'
// import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

import store from './store'
import banner from './modules/banner'
import board from './modules/board'
import broadcast from './modules/broadcast'
import schedule from './modules/schedule'
import channel from './modules/channel'
import cable from './modules/cable'
import contact from './modules/contact'
import program from './modules/program'
import link from './modules/link'


export default new Vuex.Store({
  modules: {
    store,
    banner,
    broadcast,
    schedule,
    channel,
    cable,
    contact,
    program,
    link,
    board
  },
  plugins: [
    // createPersistedState({
    //   key: "vuex_persist",
    //   paths: ['store'],
    //   storage: window.localStorage
    // })
  ]
})